import React from "react";
import PropTypes from "prop-types";
import styles from "./FooterLinks.module.css";

const FooterLinks = ({
  className = "",
  links = [
    {
      href: "/terms-of-use",
      text: "Terms of use",
      ariaLabel: "Read terms of use (opens in new window)",
      target: "_blank",
      rel: "noopener noreferrer",
    },
    {
      href: "https://www.engie.co.uk/privacy-notice-and-cookies/",
      target: "_blank",
      rel: "noopener noreferrer",
      text: "Privacy policy",
      ariaLabel: "Read privacy policy (opens in new page)",
    },
  ],
}) => {
  const footerLinksClasses = [styles.footerLinks, className]
    .filter(Boolean)
    .join(" ");

  return (
    <nav className={footerLinksClasses} aria-label="Footer navigation">
      {links.map((link) => (
        <a
          key={link.href}
          href={link.href}
          className={styles.footerLink}
          aria-label={link.ariaLabel}
          target={link.target}
          rel={link.rel}
        >
          {link.text}
        </a>
      ))}
    </nav>
  );
};

FooterLinks.propTypes = {
  className: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      ariaLabel: PropTypes.string,
      target: PropTypes.string,
      rel: PropTypes.string,
    }),
  ),
};

export default FooterLinks;
